var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("mask",{"id":"a","x":"0","y":"0","width":"39","height":"39","maskUnits":"userSpaceOnUse"},React.createElement("g",{"transform":"translate(229.43 -1.76)"},React.createElement("polygon",{"points":"-229.43 1.76 -190.43 1.76 -190.43 40.76 -229.43 40.76 -229.43 1.76","fill":"#fff","fillRule":"evenodd"})))),React.createElement("g",{"mask":"url(#a)","key":1},React.createElement("path",{"d":"M-209.93,1.76a19.54,19.54,0,0,0-19.5,19.58,19.54,19.54,0,0,0,16.25,19.29V25.43h-4.71V20h4.71v-4c0-4.68,2.84-7.23,7-7.23a37,37,0,0,1,4.2.22V13.8h-2.88c-2.26,0-2.7,1.08-2.7,2.66V20h5.4l-.71,5.48h-4.69V40.76a19.55,19.55,0,0,0,17.13-19.42,19.54,19.54,0,0,0-19.5-19.58","transform":"translate(229.43 -1.76)","fill":"#f0534c","fillRule":"evenodd"}))]);
}

Facebook.defaultProps = {"viewBox":"0 0 39 39"};

module.exports = Facebook;

Facebook.default = Facebook;
